// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const appendFormData = (formData: FormData, data: Record<string, any>, parentKey = '') => {
  Object.entries(data).forEach(([key, value]) => {
    const formKey = parentKey ? `${parentKey}[${key}]` : key;

    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (typeof item === 'object' && item !== null) {
          appendFormData(formData, item, `${formKey}[${index}]`);
        } else {
          formData.append(`${formKey}[${index}]`, item ?? '');
        }
      });
    } else if (typeof value === 'object' && value !== null) {
      appendFormData(formData, value, formKey);
    } else {
      formData.append(formKey, value ?? '');
    }
  });
};
